import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper } from "@material-ui/core";
import { Map } from "./mapDualMode";

export default function MapWrapper(props) {
  const useStyles = makeStyles((theme) => ({
    paper: {
      backgroundColor: theme.palette.background.paper,
      height: props.height || "40vh",
      color: theme.palette.text.secondary,
    },
    title: {
      flexGrow: 1,
    },
  }));
  const classes = useStyles();
  return (
    <Grid item>
      <Paper className={classes.paper}>
        <Map {...props} />
      </Paper>
    </Grid>
  );
}
